import React, { useState } from 'react';
import { Col, Input, Row } from 'reactstrap';
import Button from 'tsx/components/Button';

import { InputProps } from '~components/form-fields';
import * as FormInput from '~components/form-fields/inputs';

function FormInputTravelTime({ id, value = '', disabled, onChange }: InputProps) {
  const [override, setOverride] = useState(false);
  const message = !value ? 'Not entered' : `${value} mins`;

  return (
    <Row className="align-items-center">
      <Col className="d-flex align-items-center">
        {override && (
          <>
            <Input
              type="number"
              name={id}
              id={id}
              disabled={disabled}
              value={value ?? ''}
              className="w-50"
              onChange={({ target: { name, value } }) => onChange && onChange(name, value)}
              data-cy={`${id}-input`}
            />
            <span className="ms-2">mins</span>
          </>
        )}
        {!override && <FormInput.ReadOnly type="readonly" name={id} id={id} value={message} dataCy={id} />}
      </Col>
      <Col>
        {!override && (
          <Button
            type="button"
            size="sm"
            color="success"
            onClick={() => setOverride(!override)}
            dataCy={`${id}-override-button`}
          >
            Override
          </Button>
        )}
      </Col>
    </Row>
  );
}

export default FormInputTravelTime;
